import { PackZoneAdmin, CreatePackZoneAdminRequest, UpdatePackZoneAdminRequest } from '../types/packZone';
import { AuthService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

class PackZoneServiceClass {
  private getBaseUrl(): string {
    const userContext = AuthService.getUserDataFromToken();
    if (!userContext) {
      throw new Error('No user context available');
    }
    return `${API_BASE_URL}/${userContext.companyNo}/packzone`;
  }

  async getPackZones(): Promise<PackZoneAdmin[]> {
    const url = this.getBaseUrl();
    const response = await AuthService.authenticatedGet(url);
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }
    const data = await response.json();
    const zones = Array.isArray(data) ? data : [];
    return zones.map((z: any) => ({ ...z, id: z.packZoneID }));
  }

  async getPackZone(packZoneId: string): Promise<PackZoneAdmin> {
    const url = `${this.getBaseUrl()}/${encodeURIComponent(packZoneId)}`;
    const response = await AuthService.authenticatedGet(url);
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }
    const data = await response.json();
    return { ...data, id: data.packZoneID };
  }

  async createPackZone(request: CreatePackZoneAdminRequest): Promise<PackZoneAdmin> {
    const url = this.getBaseUrl();
    const response = await AuthService.authenticatedPost(url, request);
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }
    return await response.json();
  }

  async updatePackZone(packZoneId: string, request: UpdatePackZoneAdminRequest): Promise<PackZoneAdmin> {
    const url = `${this.getBaseUrl()}/${encodeURIComponent(packZoneId)}`;
    const response = await AuthService.authenticatedPut(url, request);
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }
    return await response.json();
  }

  async deletePackZone(packZoneId: string): Promise<void> {
    const url = `${this.getBaseUrl()}/${encodeURIComponent(packZoneId)}`;
    const response = await AuthService.authenticatedFetch(url, { method: 'DELETE' });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }
  }
}

export const packZoneService = new PackZoneServiceClass();
